import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIErrorMessage from 'UIComponents/error/UIErrorMessage';
import { jsx as _jsx } from "react/jsx-runtime";
const NoAccess = () => /*#__PURE__*/_jsx(UIErrorMessage, {
  illustration: "keys",
  title: I18n.text('noAccess.title'),
  children: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "noAccess.message"
  })
});
export default NoAccess;